import type { ReactNode } from 'react';

/**
 * Shared contracts and layout constants for the ledger shell. Nothing here
 * knows about bookings, statuses or money — a files browser or a users list
 * can drive the same shell with its own columns.
 */

/**
 * Width of the trailing Value column. Fixed (not flexed) so row values, band
 * totals and subtotal strips all land on the same right edge.
 */
export const VALUE_WIDTH = 118;

/** Flex grow of the title cell relative to the configured columns. */
export const TITLE_FLEX = 2.4;

/** Width of the lead slot, so titles line up whatever the lead renders. */
export const LEAD_WIDTH = 8;

/** One flexed column between the title cell and the Value column. */
export interface LedgerColumn {
  /** Matches a key in the row's cell map; unmatched keys render empty. */
  key: string;
  label: string;
  flex: number;
}

/** Cell content by column key. Keys with no matching column are ignored. */
export type LedgerCells = Record<string, ReactNode>;

/** The single context-menu item a row may offer on right-click. */
export interface LedgerRowMenu {
  label: string;
  disabled?: boolean;
  onSelect: () => void;
  /** Set on the rendered menu item — the e2e handle for the action. */
  'data-testid'?: string;
}

/**
 * The screen's collapse point. The screen owns the CSS container (see
 * `ledgerContainerSx`) and names it; the ledger only reads that name.
 */
export interface LedgerCollapse {
  /** CSS `container-name` declared by the screen's scroll container. */
  container: string;
  /** Width in px at or below which columns hide and rows show their meta line. */
  at: number;
}
